const GET_SERVICE_RESPONSE_RATE = 'GET_SERVICE_RESPONSE_RATE';
const GET_SERVICE_RESPONSE_RATE_SUCCESS = 'GET_SERVICE_RESPONSE_RATE_SUCCESS';
const GET_SERVICE_RESPONSE_RATE_ERROR = 'GET_SERVICE_RESPONSE_RATE_ERROR';

const getServiceResponseRate = () => {
    return {
        type: GET_SERVICE_RESPONSE_RATE
    };
};

const getServiceResponseRateSuccess = (data) => {
    return {
        type: GET_SERVICE_RESPONSE_RATE_SUCCESS,
        data
    };
};

const getServiceResponseRateError = (error) => {
    return {
        type: GET_SERVICE_RESPONSE_RATE_ERROR,
        error
    };
};

export default {
    types: {
        GET_SERVICE_RESPONSE_RATE,
        GET_SERVICE_RESPONSE_RATE_SUCCESS,
        GET_SERVICE_RESPONSE_RATE_ERROR
    },
    actions: {
        getServiceResponseRate,
        getServiceResponseRateSuccess,
        getServiceResponseRateError
    }
}

